import React, {Component} from 'react'
import HomeComponant from '../../_Componants/Home/Home'

export default class Home extends Component {
    render() {
        return (<div>
            <HomeComponant/>
        </div>)
    }
}